import { render, staticRenderFns } from "./screen-pdf.vue?vue&type=template&id=8378975e"
import script from "./screen-pdf.vue?vue&type=script&lang=ts"
export * from "./screen-pdf.vue?vue&type=script&lang=ts"
import style0 from "./screen-pdf.vue?vue&type=style&index=0&id=8378975e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports